export const REC_LABELS = {
  san_valentino: "San Valentino",
  festa_della_donna: "Festa della Donna",
  festa_del_papa: "Festa del Papà",
  primavera: "Primavera",
  pasqua: "Pasqua",
  festa_della_mamma: "Festa della Mamma",
  festa_dei_nonni: "Festa dei Nonni",
  tutti_i_santi: "Tutti i Santi",
  natale: "Natale",
  compleanno: "Compleanno",
};
